import ev1state from "@/core/ev1/state"

export const getCustomAffinities = ev1state("affinityScores")
